<script>
import { mapGetters} from 'vuex';
import TweenMax, {Power3, Linear} from 'gsap/TweenMax';
import config from '@/config';

export default {
  name: 'APropos',
  computed: {
    ...mapGetters({
      locale: 'I18n/locale',
    }),
  },
  mounted() {
    config.ga('a-propos(fin)', this.locale);

    TweenMax.from(this.$el, 1, {alpha:0, ease:Linear.easeNone, delay:.2});
  },
  methods: {
    leave() {

      this.$store.dispatch('Sound/FADE', {
          fromSound: 'fond',
          volumeFrom: config.SOUNDS.fond.volume,
          volumeTo: 0,
          duration: 2
        });

      TweenMax.to(this.$el, 2, {alpha:0, ease:Power3.easeInOut, onComplete: () => {
        TweenMax.delayedCall(.25, () => {
          this.$router.push({name:`Intro`});
        });
      }});
    }
  }
}
</script>

<template>
  <div class="APropos"> 
    <div class='wrapper'>
      <div class="intro">
        <img class='logo' :src="`/assets/logos/titrePropos-${locale}.svg`" alt="logo Apropos" />
        <p v-html="$t('about.intro')"></p>
        <div class="back">
          <a href="#" class='link' @click.prevent="leave" v-html="$t('about.back')"></a>
        </div>
      </div>
      <hr class="sep">
      <div class="credits">
        <h2 v-html="$t('credits.title')" />
        <h3 v-html="$t('credits.interns')" />
        <hr class="sep -titre">
        <h4 v-html="$t('credits.illustration')" />
        <p v-html="$t('credits.illustration_n')" />
        <h4 v-html="$t('credits.prod_son')" />
        <p v-html="$t('credits.prod_son_n')" />
        <h4 v-html="$t('credits.search')" />
        <p v-html="$t('credits.search_n')" />
        <h4 v-html="$t('credits.prog')" />
        <p v-html="$t('credits.prog_n')" />
        <h4 v-html="$t('credits.da')" />
        <p v-html="$t('credits.da_n')" />
        <h4 v-html="$t('credits.prod')" />
        <p v-html="$t('credits.prod_n')" />
        <h3 v-html="$t('credits.collaborateurs')" />
        <hr class="sep -titre">
        <h4 v-html="$t('credits.musique')" />
        <p v-html="$t('credits.musique_n')" />
        <h4 v-html="$t('credits.dev')" />
        <p v-html="$t('credits.dev_n')" />
        <h4 v-html="$t('credits.validate')" />
        <p v-html="$t('credits.validate_n')" />
        <h3 v-html="$t('credits.nfb_team')" />
	<h4 v-html="$t('credits.prod_e_title')" />
	<p v-html="$t('credits.prod_e1')" />
	<p v-html="$t('credits.prod_e2')" />
        <h4 v-html="$t('credits.prod_man_title')" />
        <p v-html="$t('credits.prod_man1')" />
        <p v-html="$t('credits.prod_man2')" />
        <p v-html="$t('credits.prod_man3')" />
        <h4 v-html="$t('credits.ed_man_title')" />
        <p v-html="$t('credits.ed_man1')" />
        <h4 v-html="$t('credits.tech_man_title')" />
        <p v-html="$t('credits.tech_man1')" />
        <h4 v-html="$t('credits.it_title')" />
        <p v-html="$t('credits.it1')" />
        <h4 v-html="$t('credits.inter_med_title')" />
        <p v-html="$t('credits.inter_med1')" />
        <h4 v-html="$t('credits.adm_title')" />
        <p v-html="$t('credits.adm1')" />
        <h4 v-html="$t('credits.prod_coord_title')" />
        <p v-html="$t('credits.prod_coord1')" />
        <br><br><br>
      </div>
    </div>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.APropos {
  position: relative;
  width: 100%;
  height: calc(100% - #{$header-height});
  margin: 0px;
  @include flexbox(center-vertical);

  @include ipad(landscape) {
    display: none;
  }
}

.wrapper {
  padding: 0 10%;
  overflow: scroll;
  text-align: center;
  @include font($ff-canal-light, $size: 12px, $color: $c-shamrock, $lineHeight: 17px);

  @include ipad {
    font-size: 1rem;
    line-height: 1.4;
  }
}

.logo {
  width: 45%;
  height: auto;
  margin: 30px auto;
}

.aPropos p {
  font-family:'Canal-Light';
  font-size:0.78em;
  line-height: 1.4;

  @include ipad {
    font-size: 1rem;
    line-height: 1.4;
  }
}

.back {
  width: 45vw;
  height: 25vw;
  margin: auto;
  background-image:url("/assets/return.svg");
  background-repeat:no-repeat;
  background-size:100% 100%;
  background-position: center center;
  @include flexbox(center-vertical);

  img {
    width : 100%
  }

  .link {
    @include font($ff-double-medium, $size: 14px, $lineHeight: 17px, $color: $c-shamrock);
    text-decoration: none;

    @include ipad {
      font-size: 1rem;
      line-height: 1.4;
    }
  }
}

.sep{
  border: 0.75px solid #31caaf;
  opacity:0.25;
  margin:40px auto;
  width:60%;

  &.-titre {
    margin:20px auto;
    width:10%;
  }
}


.credits{
  h2, h3 {
    margin-top:25px;
  }
  h2 {
    @include font($ff-double-medium, $size: 32px, $lineHeight: 32px, $color: $c-shamrock);

    @include ipad {
      font-size: 42px;
      line-height: 42px;
    }
  }

  h3 {
    @include font($ff-double-medium, $size: 20px, $lineHeight: 20px, $color: $c-shamrock);
    margin:30px 0 20px 0;

    @include ipad {
      font-size: 1rem;
      line-height: 1.4;
      margin: 40px 0 30px 0;
    }
  }

  h4 {
    @include font($ff-double-medium, $size: 14px, $lineHeight: 14px, $color: $c-shamrock);
    margin: 15px 0 5px 0;

     @include ipad {
      font-size: 1rem;
      line-height: 1.4;
      margin: 25px 0 10px 0;
    }
  }

  h2, h3, h4 {
    font-family: $ff-double-medium;
  }

  p{
    margin: 0;
  } 
}
</style>
